import React from 'react'
import Navbar from '../Home/Navbar';
import Details from './Details';

function AllAbout() {
  return (
    <div>
        <Navbar/>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <Details/>
    </div>
  )
}

export default AllAbout 